import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS, PAGE_OPERATION_TYPE } from "../../../helpers/constants";
import apiInstance from "../../instances/apiInstance";
import { DropDownData } from "./models";

export const useGetCountryListByPage = (
  pageType = "",
  operationType = PAGE_OPERATION_TYPE.ADD,
) => {
  return useQuery({
    queryKey: ["getCountryListByPage", pageType, operationType],
    queryFn: async (): Promise<DropDownData[]> => {
      const res = await apiInstance.get(
        API_ENDPOINTS.GET_COUNTRY_LIST_BY_PAGE(pageType, operationType),
      );
      return res.data[0]?.items ?? [];
    },
    retry: false,
  });
};
